// @generated by protoc-gen-es v2.9.0 with parameter "import_extension=js"
// @generated from file services/management/api/user_bookmark.proto (package gx.management.api, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_services_database_models_public } from "../../database/models/public_pb.js";
import { file_services_management_resources_user_bookmark } from "../resources/user_bookmark_pb.js";
import { file_shared_pagination } from "../../../shared/pagination_pb.js";
import { file_shared_sorting } from "../../../shared/sorting_pb.js";

/**
 * Describes the file services/management/api/user_bookmark.proto.
 */
export const file_services_management_api_user_bookmark = /*@__PURE__*/
  fileDesc("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", [file_services_database_models_public, file_services_management_resources_user_bookmark, file_shared_pagination, file_shared_sorting]);

/**
 * Describes the message gx.management.api.ListUserBookmarksRequest.
 * Use `create(ListUserBookmarksRequestSchema)` to create a new message.
 */
export const ListUserBookmarksRequestSchema = /*@__PURE__*/
  messageDesc(file_services_management_api_user_bookmark, 0);

/**
 * Describes the message gx.management.api.ListUserBookmarksResponse.
 * Use `create(ListUserBookmarksResponseSchema)` to create a new message.
 */
export const ListUserBookmarksResponseSchema = /*@__PURE__*/
  messageDesc(file_services_management_api_user_bookmark, 1);

/**
 * Describes the message gx.management.api.GetUserBookmarkByExternalIdRequest.
 * Use `create(GetUserBookmarkByExternalIdRequestSchema)` to create a new message.
 */
export const GetUserBookmarkByExternalIdRequestSchema = /*@__PURE__*/
  messageDesc(file_services_management_api_user_bookmark, 2);

/**
 * Describes the message gx.management.api.GetUserBookmarkByExternalIdResponse.
 * Use `create(GetUserBookmarkByExternalIdResponseSchema)` to create a new message.
 */
export const GetUserBookmarkByExternalIdResponseSchema = /*@__PURE__*/
  messageDesc(file_services_management_api_user_bookmark, 3);

/**
 * Describes the message gx.management.api.CreateUserBookmarkRequest.
 * Use `create(CreateUserBookmarkRequestSchema)` to create a new message.
 */
export const CreateUserBookmarkRequestSchema = /*@__PURE__*/
  messageDesc(file_services_management_api_user_bookmark, 4);

/**
 * Describes the message gx.management.api.CreateUserBookmarkResponse.
 * Use `create(CreateUserBookmarkResponseSchema)` to create a new message.
 */
export const CreateUserBookmarkResponseSchema = /*@__PURE__*/
  messageDesc(file_services_management_api_user_bookmark, 5);

/**
 * Describes the message gx.management.api.DeleteUserBookmarkRequest.
 * Use `create(DeleteUserBookmarkRequestSchema)` to create a new message.
 */
export const DeleteUserBookmarkRequestSchema = /*@__PURE__*/
  messageDesc(file_services_management_api_user_bookmark, 6);

/**
 * Describes the message gx.management.api.DeleteUserBookmarkResponse.
 * Use `create(DeleteUserBookmarkResponseSchema)` to create a new message.
 */
export const DeleteUserBookmarkResponseSchema = /*@__PURE__*/
  messageDesc(file_services_management_api_user_bookmark, 7);

/**
 * Describes the message gx.management.api.DeleteUserBookmarkByExternalIdRequest.
 * Use `create(DeleteUserBookmarkByExternalIdRequestSchema)` to create a new message.
 */
export const DeleteUserBookmarkByExternalIdRequestSchema = /*@__PURE__*/
  messageDesc(file_services_management_api_user_bookmark, 8);

/**
 * Describes the message gx.management.api.DeleteUserBookmarkByExternalIdResponse.
 * Use `create(DeleteUserBookmarkByExternalIdResponseSchema)` to create a new message.
 */
export const DeleteUserBookmarkByExternalIdResponseSchema = /*@__PURE__*/
  messageDesc(file_services_management_api_user_bookmark, 9);

/**
 * @generated from service gx.management.api.UserBookmarkService
 */
export const UserBookmarkService = /*@__PURE__*/
  serviceDesc(file_services_management_api_user_bookmark, 0);

